module.exports = __webpack_public_path__ + "static/green_abishai-e17b067ebe937e43e3a6fad960248808.png";